<template>
  <div>
    <!-- Property Booking -->
    <property-read-only-info
      v-model="form.property"
      :property="form.property"
      :properties="properties"
      :error-messages="
        $store.state.validation && !form.property_id && !form.property
          ? [$t('required')]
          : []
      "
      @search="onPropertySearch"
    />
    <v-card class="border-1 outlined m-1 mt-0 p-1 rental-contract-from">
      <v-container fluid class="mb-0 removed-container" style="">
        <!-- New Design Ends Here -->

        <v-row class="border-b align-center">
          <v-col cols="12" sm="12" md="4">
            <h4 class="text-blue-color d-flex align-center">
              <v-icon class="text-blue-color mr-2" dark right>
                mdi-card-account-details </v-icon
              >{{
                formMode === "add"
                  ? $t("rentals.create_new")
                  : $t("rentals.edit")
              }}
              {{ $t("rentals.rental_contract") }}
            </h4>
          </v-col>
          <v-spacer></v-spacer>
          <div>
            <v-btn
              id="top-print"
              class="ma-2 text-white-color"
              color="primary"
              disabled
              v-if="formMode === 'edit'"
            >
              {{ $t("rentals.print_contract") }}
              <v-icon dark right> mdi-printer </v-icon>
            </v-btn>
            <v-btn
              v-if="formMode === 'edit'"
              @click="attachmentDialog = true"
              id="top-attachments"
              class="ma-2 text-white-color"
              color="success"
            >
              {{ $t("attachments") }} ({{
                $store.state.attachmentCounts["rentals"]
                  ? $store.state.attachmentCounts["rentals"]
                  : 0
              }})
              <v-icon dark right> mdi-paperclip </v-icon>
            </v-btn>
            <v-btn
              v-if="formMode === 'edit'"
              id="top-delete"
              class="ma-2 text-white-color"
              color="error"
              @click="askDeleteConfirmation"
            >
              {{ $t("nav_buttons.delete") }}
              <v-icon dark right> mdi-delete </v-icon>
            </v-btn>

            <v-btn
              id="top-cancel"
              class="ma-2 text-black-color"
              color="grey lighten-2"
              @click="cancelRental"
            >
              {{ $t("nav_buttons.cancel") }}
              <v-icon dark right> mdi-keyboard-return </v-icon>
            </v-btn>
            <v-btn
              id="top-save"
              class="ma-2 text-white-color"
              color="success"
              @click="saveData"
            >
              {{ $t("nav_buttons.save") }}
              <v-icon dark right> mdi-content-save </v-icon>
            </v-btn>
          </div>
        </v-row>

        <!-- Heading Ends Here -->
        <v-divider class="mt-5"></v-divider>
      </v-container>
      <div>
        <div class="mt-0 removed-container" style="margin: 10px !important">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <h4 class="text-blue-color">
                {{ $t("rentals.contract_details") }}
              </h4>
            </v-col>

            <v-col cols="12" sm="12" md="3" class="d-none">
              <v-select
                v-model="form.family_client_id"
                :items="familyClients"
                :label="$t('pricing_rule.family_client')"
                item-value="id"
                item-text="name"
                :outlined="is_boxes"
                :dense="is_boxes"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-combobox
                autocomplete="off"
                ref="clientName"
                v-model="form.client"
                :items="company_client_names"
                item-value="id"
                item-text="name"
                :label="
                  form.client?.representative_company_id
                    ? $t('billings.comp_name')
                    : $t('billings.family_name')
                "
                class="to-upper"
                required
                append-icon="mdi-close"
                v-on:keydown="handleInput($event, 'everything', 50)"
                :search-input.sync="search_client"
                no-filter
                v-on:keydown.enter.prevent=""
                @click:append="clearClient"
                @input="onClientInput"
                @blur="onClientBlur"
                :error-messages="
                  $store.state.validation && !hasValidClient
                    ? [this.$t('vehicles.text_messages.client_required')]
                    : []
                "
                return-object
                :outlined="is_boxes"
                :dense="is_boxes"
              >
                <template slot="selection" slot-scope="{ item }">
                  {{ getClientLastName(item) }}
                </template>
                <template slot="item" slot-scope="{ item }">
                  <v-list-item-content>
                    <p class="client_name">
                      {{ item.name ? item.name : "" }}
                      {{ item.first_name ? " " + item.first_name : "" }}
                    </p>
                    <p
                      class="client_detail"
                      v-if="item.representative_company_id"
                    >
                      {{ $t("entity_type.company") }}
                    </p>
                    <p class="client_detail" v-else>
                      {{ $t("entity_type.private") }}
                    </p>
                  </v-list-item-content>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-text-field
                autocomplete="off"
                ref="clientFirstName"
                v-model="form.client_first_name"
                class="to-upper"
                :label="$t('billings.client_first_name')"
                v-on:keydown="handleInput($event, 'everything', 50)"
                @blur="onClientBlur"
                :outlined="is_boxes"
                :dense="is_boxes"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="3">
              <v-menu
                v-model="menuDtpStart"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.start_date"
                    :label="$t('rentals.start_date')"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:append="form.start_date = null"
                    append-icon="mdi-close"
                    class="mr-2 to-upper"
                    :outlined="is_boxes"
                    :dense="is_boxes"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :first-day-of-week="1"
                  :weekday-format="getDay"
                  v-model="form.start_date"
                  :min="today"
                  @input="menuDtpStart = false"
                  no-title
                  scrollable
                  :locale="userLanguageId"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-menu
                v-model="menuDtpEnd"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.end_date"
                    :label="$t('rentals.end_date')"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:append="form.end_date = null"
                    append-icon="mdi-close"
                    class="mr-2 to-upper"
                    :outlined="is_boxes"
                    :dense="is_boxes"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :first-day-of-week="1"
                  :weekday-format="getDay"
                  :min="form.start_date"
                  :max="form.extended_date"
                  v-model="form.end_date"
                  @input="menuDtpEnd = false"
                  no-title
                  scrollable
                  :locale="userLanguageId"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="12" md="9">
              <v-text-field
                autocomplete="off"
                v-model="form.contract_reference"
                class="to-upper"
                name="client_contract_ref"
                v-on:keydown="handleInput($event, 'alphanumeric', 100)"
                :label="$t('rentals.reference')"
                :outlined="is_boxes"
                :dense="is_boxes"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-menu
                v-model="colorMenu"
                nudge-bottom="105"
                nudge-left="16"
                :close-on-content-click="false"
                hide-details
              >
                <template v-slot:activator="{ on }">
                  <div class="color-picker-wrapper">
                    <div :style="colorSwatchStyle" v-on="on" />
                    <v-text-field
                      :value="colorLocal"
                      :label="$t('rentals.appointment_color')"
                      readonly
                      :outlined="is_boxes"
                      :dense="is_boxes"
                      hide-details
                      v-on="on"
                    />
                  </div>
                </template>
                <v-card>
                  <v-card-text class="pa-0">
                    <v-color-picker
                      v-model="colorLocal"
                      mode="hexa"
                      class="mt-10"
                      flat
                      @input="onColorChanged"
                    />
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-col>
          </v-row>

          <v-row class="mt-5">
            <v-col cols="12" sm="12" md="12">
              <h4 class="mb-3" style="color: #9b9b9b; font-weight: normal">
                {{ $t("rentals.note") }}
              </h4>
              <wysiwyg v-model="form.note" />
            </v-col>
          </v-row>
          <br />
        </div>
      </div>

      <attachment-dialog
        v-if="attachmentDialog"
        :showDialog.sync="attachmentDialog"
        :data="rentalId"
        :countKey="'rentals'"
        :resource="'rentals'"
      ></attachment-dialog>

      <confirmation-model
        v-if="confirmationDialog"
        :showDialog.sync="confirmationDialog"
        :openedForOperation.sync="confirmationDialogOperation"
        :text.sync="confirmationDialogConfirmationText"
        :trueText.sync="confirmationDialogTrueText"
        :falseText.sync="confirmationDialogFalseText"
        @buttonClicked="confirmationButtonClicked"
      ></confirmation-model>
    </v-card>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import axios from "@/plugins/axios";
import { API_BASE_URL } from "@/config";
import AttachmentDialog from "@/components/AttachmentDialog";
import ConfirmationModel from "@/components/ConfirmationModel";
import moment from "moment";
import PropertyReadOnlyInfo from "@/components/PropertyReadOnlyInf.vue";
export default {
  name: "AddPropertyRentalsHistory",
  mixins: [validationMixin],
  components: {
    "attachment-dialog": AttachmentDialog,
    "confirmation-model": ConfirmationModel,
    "property-read-only-info": PropertyReadOnlyInfo,
  },
  props: {
    showBookingDialog: [Boolean],
  },
  data() {
    return {
      isTrue: true,
      rentalHistory: null,
      rentalId: this.$store.state.rentalId,
      is_edit: (this.$route.path.includes("edit") ? "edit" : "add") === "edit",
      company_client_names: [],
      properties: [],
      autocompleteValueLocal: false,
      search_client: null,
      search_property: null,
      is_boxes: this.getCompanyPropertyFromLocalStorage("boxes_on_fields", 1),
      token: this.$store.state.AccessToken,
      header: { Authorization: "Bearer " + this.$store.state.AccessToken },
      menuDtp: false,
      menuDtpStart: false,
      menuDtpEnd: false,
      attachmentDialog: false,
      confirmationDialog: false,
      confirmationDialogOperation: null,
      confirmationDialogConfirmationText: null,
      confirmationDialogTrueText: null,
      confirmationDialogFalseText: null,
      confirmationDialogButtonClickedIs: null,
      colorMenu: false,
      colorLocal: null,
      isSyncingFromApi: false,
      form: {
        identifier: null,
        client: null,
        client_first_name: "",
        family_client_id: null,
        client_reference: null,
        contract_reference: null,
        property: null,
        property_id: null,
        property_name: null,
        start_date: new Date().toISOString().substr(0, 10),
        end_date: new Date().toISOString().substr(0, 10),
        note: null,
        color: null,
      },
    };
  },
  beforeDestroy() {
    this.$store.commit("setPropertyRentalEditIdentifier", null);
    if (this.formMode === "add") {
      this.$store.commit("setPropertyForNewRental", null);
    }
  },
  created() {
    if (this.formMode === "add") {
      this.fetchPropertiesOnCreate();
      if (this.defaultFamilyClientId) {
        this.form.family_client_id = this.defaultFamilyClientId;
      }
    }
    if (this.formMode === "edit") {
      if (!this.rentalId) {
        this.$router.push("/property-rentals");
        return;
      }
      this.setRentalHistory();
      this.fetchProperties();
    }
  },
  methods: {
    falseButtonClicked() {
      this.$store.commit("setRentalVehicleForm", false);
    },
    showAttachmentDialog() {
      this.attachmentDialog = true;
    },
    getPropertyName(property) {
      if (!property) {
        return "";
      }
      if (typeof property === "string") {
        return property;
      }
      return property.name || property.property_name || "";
    },
    getClientLastName(item) {
      if (!item) return "";
      if (typeof item === "string") return item;
      return item.name || "";
    },
    clearClient() {
      this.form.client = null;
      this.form.client_first_name = "";
      this.form.family_client_id = this.defaultFamilyClientId;
      this.company_client_names = [];
    },
    onClientInput(val) {
      if (val && typeof val === "object" && val.first_name !== undefined) {
        this.form.client_first_name = (val.first_name || "").toUpperCase();
        this.form.family_client_id = val.family_client_id || this.defaultFamilyClientId;
        if (val.name) {
          this.form.client = { ...val, name: (val.name || "").toUpperCase() };
        }
      } else if (typeof val === "string") {
        this.form.family_client_id = this.defaultFamilyClientId;
        if (val) {
          this.$nextTick(() => {
            this.form.client = val.toUpperCase();
          });
        }
      } else if (!val) {
        this.form.client_first_name = "";
        this.form.family_client_id = this.defaultFamilyClientId;
      }
    },
    onClientBlur() {
      if (this.form.client) {
        if (typeof this.form.client === "string") {
          this.form.client = this.form.client.toUpperCase();
        } else if (
          this.form.client.name &&
          this.form.client.name !== this.form.client.name.toUpperCase()
        ) {
          this.form.client = {
            ...this.form.client,
            name: this.form.client.name.toUpperCase(),
          };
        }
      }
      if (this.form.client_first_name) {
        this.form.client_first_name = this.form.client_first_name.toUpperCase();
      }
    },
    onPropertySearch(search) {
      this.search_property = search;
    },
    onColorChanged(value) {
      const hex = value && (typeof value === "string" ? value : value?.hex);
      this.form.color = hex || null;
    },
    formPayload() {
      return this.makeSumbitData();
    },
    makeSumbitData() {
      const clientId =
        this.form.client && typeof this.form.client === "object" && this.form.client.id
          ? this.form.client.id
          : null;
      const clientName =
        this.form.client && typeof this.form.client === "object"
          ? (this.form.client.name || "").trim()
          : typeof this.form.client === "string"
          ? this.form.client.trim()
          : "";
      const familyClientId =
        this.form.family_client_id ||
        (this.form.client && typeof this.form.client === "object" && this.form.client.family_client_id) ||
        this.defaultFamilyClientId;
      return {
        identifier: this.form.identifier,
        client: {
          id: clientId,
          name: clientName,
          first_name: (this.form.client_first_name || "").trim(),
          family_client_id: familyClientId,
        },
        client_reference: this.form.client_reference,
        contract_reference: this.form.contract_reference,
        property_id: this.form.property_id,
        start_date: this.form.start_date,
        end_date: this.form.end_date,
        note: this.form.note,
        color: this.form.color ? String(this.form.color).replace(/^#/, "") : null,
      };
    },
    setRentalHistory() {
      axios
        .get(API_BASE_URL + "/property_rentals/" + this.rentalId, {
          headers: this.header,
        })
        .finally(() => this.$store.commit("setLoading", false))
        .then((response) => {
          let history = response?.data?.data ?? response?.data;
          this.rentalHistory = history;
          this.$store.commit(
            "setPropertyRentalEditIdentifier",
            history?.identifier || null
          );
          this.isSyncingFromApi = true;
          // Fill Form Data
          this.form = history;
          const appointmentColor =
            history?.appointment_color ?? this.form?.appointment_color;
          if (appointmentColor) {
            const hexColor = String(appointmentColor).startsWith("#")
              ? appointmentColor
              : "#" + String(appointmentColor).replace(/^#/, "");
            this.$set(this.form, "color", hexColor);
            this.colorLocal = hexColor;
          }
          if (history.client) {
            this.form.client_first_name = (history.client.first_name || "").toUpperCase();
            this.form.family_client_id =
              history.client.family_client_id || this.defaultFamilyClientId;
            if (this.form.client && this.form.client.name) {
              this.form.client = {
                ...this.form.client,
                name: (this.form.client.name || "").toUpperCase(),
              };
            }
          }
          if (history.property) {
            this.form.property = history.property;
            this.form.property_id = history.property.id || null;
            this.form.property_name = this.getPropertyName(history.property);
          }
          this.form.start_date = moment(history.start_date).format(
            "YYYY-MM-DD"
          );
          this.form.end_date = moment(history.end_date).format("YYYY-MM-DD");
          this.$nextTick(() => {
            this.isSyncingFromApi = false;
          });
        })
        .catch((error) => {
          this.isSyncingFromApi = false;
          this.$store.commit("setPropertyRentalEditIdentifier", null);
          this.$toast.error(
            error?.response?.data?.message || this.$t("unknown_error")
          );
        });
    },

    updateData() {
      let payload = this.formPayload();
      axios
        .put(
          API_BASE_URL + "/property_rentals/" + this.$store.state.rentalId,
          payload,
          { headers: this.header }
        )
        .then(() => {
          this.$toast.success(
            this.$t("vehicles.text_messages.contract_updated_successfully")
          );
          this.$store.commit("setRentalVehicleForm", false);
          this.$router.push("/property-rentals");
        })
        .catch((error) => {
          this.$toast.error(
            error?.response?.data?.errors ||
              error?.response?.data?.errors[0] ||
              error?.response?.message ||
              "Unknown error ocurred"
          );
        })
        .finally(() => {});
    },
    addNew() {
      axios
        .post(API_BASE_URL + "/property_rentals", this.formPayload(), {
          headers: this.header,
        })
        .then(() => {
          this.$store.commit("setPropertyForNewRental", null);
          this.$toast.success(
            this.$t("vehicles.text_messages.contract_created_successfully")
          );
          this.$router.push("/property-rentals");
        })
        .catch((error) => {
          this.$toast.error(
            error?.response?.data?.errors ||
              error?.response?.data?.errors[0] ||
              error?.response?.message ||
              "Unknown error ocurred"
          );
        })
        .finally(() => {});
    },
    saveData() {
      this.$store.commit("setValidation", true);
      if (!this.hasValidClient) {
        return this.$toast.error(this.$t("rentals.client_error"));
      }

      if (!this.form.property_name && !this.form.property_id) {
        return this.$toast.error(this.$t("required"));
      }

      if (!this.form.start_date) {
        return this.$toast.error(this.$t("rentals.start_date_error"));
      }

      if (!this.form.end_date) {
        return this.$toast.error(this.$t("rentals.end_date_error"));
      }

      if (this.formMode == "edit") {
        this.updateData();
      } else {
        this.addNew();
      }
    },
    fetchClientsListDebounced() {
      if (!this.search_client || typeof this.search_client == "object") {
        return;
      }

      axios
        .get(
          API_BASE_URL +
            "/clients/search?" +
            (this.search_client
              ? "&search=" + encodeURIComponent(this.search_client)
              : ""),
          { headers: this.header }
        )
        .then(({ data }) => {
          this.company_client_names = data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    fetchPropertiesListDebounced() {
      if (!this.search_property || typeof this.search_property == "object") {
        return;
      }

      axios
        .get(
          API_BASE_URL +
            "/properties?" +
            (this.search_property
              ? "&search=" + encodeURIComponent(this.search_property)
              : ""),
          { headers: this.header }
        )
        .then(({ data }) => {
          this.properties = data.data || [];
        })
        .catch(() => {})
        .finally(() => {});
    },
    fetchProperties() {
      axios
        .get(API_BASE_URL + "/properties", { headers: this.header })
        .then(({ data }) => {
          this.properties = data.data || [];
        })
        .catch(() => {})
        .finally(() => {});
    },
    fetchPropertiesOnCreate() {
      axios
        .get(API_BASE_URL + "/properties?items_per_page=100", {
          headers: this.header,
        })
        .then(({ data }) => {
          this.properties = data.data || data || [];
          if (!Array.isArray(this.properties)) {
            this.properties = [];
          }
          if (
            this.$route.path === "/property-rentals/history/add" &&
            this.$store.state.propertyForNewRental
          ) {
            const storeProperty = this.$store.state.propertyForNewRental;
            let selectedProperty = this.properties.find(
              (p) => p && p.id === storeProperty.id
            );
            if (!selectedProperty) {
              this.properties = [storeProperty, ...this.properties];
              selectedProperty = storeProperty;
            }
            if (selectedProperty) {
              this.form.property = selectedProperty;
              this.form.property_id = selectedProperty.id || null;
              this.form.property_name = this.getPropertyName(selectedProperty);
              if (selectedProperty.color) {
                const hexColor = String(selectedProperty.color).startsWith("#")
                  ? selectedProperty.color
                  : "#" + String(selectedProperty.color).replace(/^#/, "");
                this.form.color = hexColor;
                this.colorLocal = hexColor;
              }
            }
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    cancelRental() {
      this.$store.commit("setRentalVehicleForm", false);
      this.removeRentalInfo();
    },
    askDeleteConfirmation() {
      this.confirmationDialogConfirmationText = this.$t(
        "rentals.delete_rental_contract_confirmation"
      );
      this.confirmationDialogFalseText = this.$t("nav_buttons.cancel");
      this.confirmationDialogTrueText = this.$t("nav_buttons.delete");
      this.confirmationDialogOperation = "delete";
      this.confirmationDialog = true;
    },
    confirmationButtonClicked(buttonClicked) {
      this.confirmationDialogButtonClickedIs = buttonClicked;
      this.confirmationDialog = false;
    },
    deleteContract() {
      axios
        .delete(
          API_BASE_URL + "/property_rentals/" + this.$store.state.rentalId,
          { headers: this.header }
        )
        .then(() => {
          this.$toast.success(
            this.$t("rentals.contract_deleted_successfully")
          );
          this.$store.commit("setRentalVehicleForm", false);
          this.removeRentalInfo();
        })
        .catch((error) => {
          this.$toast.error(
            error?.response?.data?.message ||
              error?.response?.data?.errors?.[0] ||
              this.$t("unknown_error")
          );
        });
    },
    removeRentalInfo() {
      this.$store.commit("setRentalId", null);
      this.$store.commit("setPropertyForNewRental", null);
      this.company_client_names = [];
      this.properties = [];
      this.autocompleteValueLocal = false;
      this.search_client = null;
      this.search_property = null;
      this.is_boxes = this.getCompanyPropertyFromLocalStorage(
        "boxes_on_fields",
        1
      );
      this.form.start_date = new Date().toISOString().substr(0, 10);
      this.attachmentDialog = false;
      this.colorLocal = null;
      this.form = {};
      this.$router.push("/property-rentals");
    },
  },
  watch: {
    search_client(val) {
      if (!val || this.client_id == val) {
        return;
      }
      clearTimeout(this._searchTimerId);
      this._searchTimerId = setTimeout(() => {
        this.fetchClientsListDebounced();
      }, 500);
    },
    search_property(val) {
      if (!val || this.property_id == val) {
        return;
      }
      clearTimeout(this._propertySearchTimerId);
      this._propertySearchTimerId = setTimeout(() => {
        this.fetchPropertiesListDebounced();
      }, 500);
    },
    "form.property"(val) {
      if (!val) {
        this.form.property_id = null;
        this.form.property_name = null;
        return;
      }
      if (typeof val === "string") {
        this.form.property_id = null;
        this.form.property_name = val;
        return;
      }
      this.form.property_id = val.id || null;
      this.form.property_name = this.getPropertyName(val);
      if (!this.isSyncingFromApi && val.color) {
        const hexColor = String(val.color).startsWith("#")
          ? val.color
          : "#" + String(val.color).replace(/^#/, "");
        this.form.color = hexColor;
        this.colorLocal = hexColor;
      }
    },
    "form.color"(newVal) {
      this.colorLocal = newVal || null;
    },
    "form.client_first_name"(val) {
      if (
        this.form.client &&
        typeof this.form.client === "object" &&
        this.form.client.id
      ) {
        this.form.client.first_name = val;
      }
    },
    confirmationDialogButtonClickedIs(newVal) {
      if (newVal === true && this.confirmationDialogOperation === "delete") {
        this.deleteContract();
      }
      this.confirmationDialogButtonClickedIs = null;
      this.confirmationDialogOperation = null;
    },
    "$store.state.familyClients"() {
      if (this.familyClients.length > 0 && this.defaultFamilyClientId) {
        const isNewName =
          typeof this.form.client === "string" && this.form.client.trim();
        const needsDefault =
          !this.form.family_client_id || isNewName;
        if (needsDefault) {
          this.form.family_client_id = this.defaultFamilyClientId;
        }
      }
    },
  },
  computed: {
    familyClients() {
      return this.$store.state.familyClients || [];
    },
    defaultFamilyClientId() {
      const defaultClient = this.familyClients.find(
        (el) => el.is_default == 1 || el.is_default === true
      );
      return defaultClient ? defaultClient.id : null;
    },
    addRentalVehicleFormActive() {
      return this.$store.state.addRentalVehicleFormActive;
    },
    formMode() {
      return this.$route.path.includes("edit") ? "edit" : "add";
    },
    today() {
      return new Date().toISOString().substr(0, 10);
    },
    hasValidClient() {
      if (!this.form.client) return false;
      if (typeof this.form.client === "object") {
        return !!this.form.client.id;
      }
      return typeof this.form.client === "string" && this.form.client.trim() !== "";
    },
    colorSwatchStyle() {
      return {
        backgroundColor: this.colorLocal || "#e0e0e0",
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: "4px",
        minWidth: "30px",
      };
    },
  },
};
</script>

<style scoped>
.rental-contract-from {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  margin-top: 30px;
}

.attachment-title {
  position: relative;
  background: #fff;
  z-index: 0;
}

.attachment-title:after {
  content: "";
  width: Calc(100% + 10px);
  height: 1px;
  display: block;
  background: rgba(0, 0, 0, 0.42);
  position: absolute;
  top: 50%;
  left: -5px;
  z-index: -1;
}

.attachment-title span {
  background: #fff;
  display: inline-block;
  width: initial;
  position: relative;
  z-index: 0;
  padding: 0 5px;
}

.print-btn {
  background-color: #fff !important;
  border: 1px solid;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

.v-select__slot {
  border: 1px solid rgba(0, 0, 0, 0.42) !important;
  border-bottom: 0;
}

.v-select__selections {
  border-right: 1px solid rgba(0, 0, 0, 0.42) !important;
}

.contract-btn {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}

.contract-btn button {
  font-size: 10px !important;
}

.color-picker-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}
.color-picker-wrapper .v-text-field {
  flex: 1;
}
</style>
